import type { ReactNode } from 'react';
import { useAuth } from '@/services/auth/authContext';
import { LandingPage } from '@/features/landing/LandingPage';
import { Spinner } from './ui/Card';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, error, signIn } = useAuth();
  const previewLanding =
    import.meta.env.DEV && new URLSearchParams(globalThis.location.search).has('landing');

  if (status === 'initializing') {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner label="Signing you in" />
      </div>
    );
  }

  if (status === 'authenticated' && !previewLanding) return <>{children}</>;

  const handleSignIn = () => {
    if (previewLanding && status === 'authenticated') {
      const url = new URL(globalThis.location.href);
      url.searchParams.delete('landing');
      globalThis.location.assign(url);
      return;
    }
    void signIn();
  };

  return <LandingPage error={error} signInDisabled={status === 'error'} onSignIn={handleSignIn} />;
}
